export function featureFlagEnabled(value) {
  return /^(1|true|yes|on)$/i.test(String(value || "").trim());
}

export const paymentsEnabled = featureFlagEnabled(
  process.env.REACT_APP_PAYMENTS_ENABLED
);
